import { useSearchParams } from 'react-router-dom';

export interface UseGetPaginationParams {
  pageIndex: number;
  pageSize: number;
}

export function useGetPaginationParams(): UseGetPaginationParams {
  const [query] = useSearchParams();
  const pageIndex = parseInt(query.get('page') ?? '') || 0;
  const pageSize = parseInt(query.get('pageSize') ?? '') || 10;
  return { pageIndex, pageSize };
}

export default useGetPaginationParams;
